import { SocialSignIn } from '@/components/SignIn'

export function SignInScreen() {
    return <SocialSignIn />
}